export const IMAGE = 'image';
export const VIDEO = 'video';
export const PDF = 'pdf';

export const PLANNING = 'planning';
export const RECURRING_POSTS = 'recurring posts';
export const CALENDAR = 'calender';
export const IG_FEED_PREVIEW = 'instagram feed preview';
export const DELAY = 'publication delay';
export const BEST_TIME_TO_POST = 'best time to post';

export const SELECT_VIDEO = 'select from video';
export const UPLOAD_FILE = 'upload file';
export const MEDIA_LIBRARY = 'media library';
export const POST_PREVIEW = 'post preview';
export const IG_GRID_PREVIEW = 'instagram grid preview';

export const SOURCE_IMAGE = 'source image';
export const EDITED_IMAGE = 'edited image';
export const THUMBNAIL_IMAGE = 'thumbnail image';
export const FULL_EDITOR_IMAGE = 'full editor image';

export const EDITOR_VIEW = 'editor_view';
export const UPLOAD_VIEW = 'upload_view';

export const MEDIA_TYPE_VIDEO = 'video';
export const MEDIA_TYPE_IMAGE = 'image';
export const MEDIA_TYPE_PDF = 'application/pdf';
export const MEDIA_TYPE_DOC = 'doc';

export const STORY = 'Story';

export const EXTERNAL = 'external';
export const LOCAL = 'local';

export const VIEW_STATUS = {
  PLANNING,
  RECURRING_POSTS,
  CALENDAR,
  IG_FEED_PREVIEW,
  DELAY,
  BEST_TIME_TO_POST
};

export const THUMBNAIL_SOURCE = {
  SELECT_VIDEO,
  UPLOAD_FILE,
  MEDIA_LIBRARY
};

export const THUMBNAIL_PREVIEWS = {
  POST_PREVIEW,
  IG_GRID_PREVIEW
};

export const DEFUALT_INPUT_TIME = '12:15';

export const BTN_SAVE_AS_DRAFT = 'save_as_draft_btn';
export const BTN_PLAN_PUBLICATION = 'plan_publication_btn';
export const BTN_PUBLISH_NOW = 'publish_now_btn';
export const BTN_SAVE_FOR_APPROVAL = 'save_for_approval_btn';
export const BTN_SAVE_FOR_APPROVAL_CLOUD = 'save_for_approval_cloud_btn';
export const BTN_PUBLISH_AND_CONFIGURE = 'publish_and_configure_btn';
export const BTN_PLAN_AND_CONFIGURE = 'plan_and_configure_btn';
export const BTN_SAVE = 'save_btn';
export const BTN_APPROVAL_REQUEST_APPROVE = 'approval_request_approve_btn';
export const BTN_APPROVAL_REQUEST_REJECT = 'approval_request_reject_btn';
export const POST_ACTION_SAVE_AS_DRAFT_ID = 1;
export const POST_ACTION_PUBLISH_NOW_ID = 2;
export const POST_ACTION_SCHEDULE_ID = 3;
export const POST_ACTION_PUBLISH_AND_CONFIGURE_ID = 4;
export const POST_ACTION_PLAN_AND_CONFIGURE_ID = 5;
export const POST_ACTION_SAVE_FOR_APPROVAL_ID = 6;
export const POST_ACTION_SAVE_ID = 7;
export const POST_ACTION_APPROVE_ID = 8;
export const POST_ACTION_REJECT_ID = 9;

export const ACTIONS_VALUES_MAP = {
  [BTN_SAVE_AS_DRAFT]: POST_ACTION_SAVE_AS_DRAFT_ID,
  [BTN_PUBLISH_NOW]: POST_ACTION_PUBLISH_NOW_ID,
  [BTN_PLAN_PUBLICATION]: POST_ACTION_SCHEDULE_ID,
  [BTN_SAVE_FOR_APPROVAL]: POST_ACTION_SAVE_FOR_APPROVAL_ID,
  [BTN_PUBLISH_AND_CONFIGURE]: POST_ACTION_PUBLISH_AND_CONFIGURE_ID,
  [BTN_PLAN_AND_CONFIGURE]: POST_ACTION_PLAN_AND_CONFIGURE_ID,
  [BTN_SAVE]: POST_ACTION_SAVE_ID,
  [BTN_SAVE_FOR_APPROVAL_CLOUD]: POST_ACTION_SAVE_FOR_APPROVAL_ID,
  [BTN_APPROVAL_REQUEST_APPROVE]: POST_ACTION_APPROVE_ID,
  [BTN_APPROVAL_REQUEST_REJECT]: POST_ACTION_REJECT_ID
};
export const DRAFT = 'draft';
export const PLANNED = 'planned';
export const LABEL_TO_ACTIONS_MAP = {
  [DRAFT]: POST_ACTION_SAVE_AS_DRAFT_ID,
  [PLANNED]: POST_ACTION_SCHEDULE_ID
};
export const ACTIONS_THAT_REQUIRE_PERMISSION = [
  BTN_PUBLISH_AND_CONFIGURE,
  BTN_PLAN_AND_CONFIGURE,
  BTN_PLAN_PUBLICATION,
  BTN_PUBLISH_NOW,
  BTN_APPROVAL_REQUEST_APPROVE,
  BTN_APPROVAL_REQUEST_REJECT
];

export const MAX_INSTAGRAM_HASHTAGS = 30;

export const isTextLengthValidKey = 'isTextLengthValid';
export const PostHasTextOrMediaKey = 'PostHasTextOrMedia';
export const isPostPublicationDateSet = 'isPostPublicationDateSet';
export const mediaIsLoadingKey = 'mediaIsLoadingKey';
export const youtubeTitleLengthKey = 'youtubeTitleLengthKey';
export const validateYoutubeTitleExistsKey = 'validateYoutubeTitleExistsKey';
export const oneMediaShouldBeSelectedKey = 'oneMediaShouldBeSelectedKey';
export const isGeneralOptionsUrlsValidKey = 'isGeneralOptionsUrlsValidKey';
export const isGeneralLinksHasTitlesKey = 'isGeneralLinksHasTitlesKey';
export const generalTitleIsRequiredKey = 'generalTitleIsRequiredKey';
export const validateLinkedinDocumentTitleExistsKey =
  'validateLinkedinDocumentTitleExistsKey';
export const validateDateIsInFutureKey = 'validateDateIsInFutureKey';
export const instagramShouldHaveLessThan20HashtagsKey =
  'instagramShouldHaveLessThan20HashtagsKey';

export const validatorsWithPlatform = [oneMediaShouldBeSelectedKey];
export const PREVIEW_TYPE_STANDARD = 'standard';
export const PREVIEW_TYPE_COMPACT = 'compact';

export const POST_STATUS_PROPOSED_BY_EXTERNAL_USER = 1;
export const POST_STATUS_DRAFT = 2;
export const POST_STATUS_WAITING_FOR_APPROVAL = 3;

export const POST_SUB_STATUS_SAVED_AS_APPROVED_POST = 3;

export const POST_STATUS_READY = 4;
export const POST_STATUS_COPYING = 5;
export const POST_STATUS_LABELS = {
  [POST_STATUS_PROPOSED_BY_EXTERNAL_USER]: 'proposed_by_external_user',
  [POST_STATUS_DRAFT]: 'draft',
  [POST_STATUS_WAITING_FOR_APPROVAL]: 'waiting_for_approval',
  [POST_STATUS_READY]: 'ready',
  [POST_STATUS_COPYING]: 'copying',
  null: 'new'
};

export const POST_PUBLISHED_ON_PLATFORM = 3;

export const TOLGEE_CANCEL_OF_ACTIVE_APPROVAL_PROCESS_NOT_ALLOWED =
  'lomavisPostApproval.changeCancelNotAllowed';

// Instagram Trial Reel graduation strategies
export const GRADUATION_STRATEGY_MANUAL = 'MANUAL';
export const GRADUATION_STRATEGY_SS_PERFORMANCE = 'SS_PERFORMANCE';

export const pinterestShouldHaveBoardSelectedKey =
  'pinterestShouldHaveBoardSelectedKey';
export const pinterestShouldHaveValidLinksKey =
  'pinterestShouldHaveValidLinksKey';

export const locationShouldBeSelectedMultiPostKey =
  'locationShouldBeSelectedMultiPostKey';
export const lomavisPostApprovalSingleStepKey =
  'lomavisPostApprovalSingleStepKey';
export const lomavisPostApprovalExistKey = 'lomavisPostApprovalExistKey';

export const lomavisPostApprovalMultiStepKey =
  'lomavisPostApprovalMultiStepKey';

export const lomavisPostApprovalWithScheduleKey =
  'lomavisPostApprovalWithScheduleKey';
export const lomavisPostApprovalSaveAsApprovedKey =
  'lomavisPostApprovalSaveAsApprovedKey';
export const validateProductLinksKey = 'validateProductLinksKey';
export const mondayStartLocales = [
  'de',
  'fr',
  'es',
  'it',
  'nl',
  'ru',
  'fi',
  'sv',
  'no',
  'da',
  'pl',
  'pt',
  'tr', // Europe
  'ja',
  'ko',
  'zh-cn',
  'th',
  'vi',
  'ms',
  'id', // Asia
  'sw',
  'ar',
  'am', // Africa
  'en-AU',
  'en-NZ' // Oceania
];

export const MAX_MEDIA_FILES = 10;

// Cloud-picker files smaller than this are downloaded into the browser and
// re-uploaded through the regular client-side pipeline (we keep HEIC
// conversion, image compression, dimension extraction, etc.). Larger files
// are streamed server-side via media_download_url to save bandwidth.
// Set high enough that typical short-form videos also go through the browser
// pipeline (we need client-side dimensions/duration extraction for the
// upload preset).
export const CLOUD_BROWSER_DOWNLOAD_THRESHOLD_BYTES = 450 * 1024 * 1024;

export const DROPBOX_PICKER = {
  scriptId: 'dropboxjs',
  sdkSrc: 'https://www.dropbox.com/static/api/2/dropins.js'
};

export const GOOGLE_DRIVE_PICKER = {
  apiScriptId: 'google-drive-api-js',
  identityScriptId: 'google-drive-identity-js',
  apiSdkSrc: 'https://apis.google.com/js/api.js',
  identitySdkSrc: 'https://accounts.google.com/gsi/client',
  scope: 'https://www.googleapis.com/auth/drive.readonly'
};

export const MEDIA_UPLOAD_IMAGE_ONLY_EXTENSIONS = [
  '.jpeg',
  '.jpg',
  '.png',
  '.heic',
  '.heif'
];

export const MEDIA_UPLOAD_ALL_EXTENSIONS = [
  ...MEDIA_UPLOAD_IMAGE_ONLY_EXTENSIONS,
  '.mov',
  '.mp4',
  '.pdf'
];

export const MEDIA_UPLOAD_IMAGE_ONLY_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/jpg',
  'image/heic',
  'image/heif',
  'image/heic-sequence',
  'image/heif-sequence'
];

export const MEDIA_UPLOAD_ALL_MIME_TYPES = [
  ...MEDIA_UPLOAD_IMAGE_ONLY_MIME_TYPES,
  'video/mov',
  'video/quicktime',
  'video/mp4',
  'application/pdf'
];

export const MEDIA_UPLOAD_EXTENSION_TO_MIME_TYPE: Record<string, string> = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  heic: 'image/heic',
  heif: 'image/heif',
  mov: 'video/quicktime',
  mp4: 'video/mp4',
  pdf: 'application/pdf'
};

export const MEDIA_UPLOAD_MIME_TYPE_TO_EXTENSION: Record<string, string> = {
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/heic': 'heic',
  'image/heif': 'heif',
  'image/heic-sequence': 'heic',
  'image/heif-sequence': 'heif',
  'video/quicktime': 'mov',
  'video/mp4': 'mp4',
  'application/pdf': 'pdf'
};

export const MAX_WIDTH_SVG = 1000;

export const LOMAVIS_TEMPLATE_POST_LOGO_PLACEHOLDER_SQUARE_URL =
  'https://app.lomavis.com/static/core/img/auto_branding/lomavis_logo_placeholder_square.2188f235831d.png';

export const LOMAVIS_TEMPLATE_POST_LOGO_PLACEHOLDER_RECTANGLE_URL =
  'https://app.lomavis.com/static/core/img/auto_branding/lomavis_logo_placeholder_rectangle.dbdeadb81677.png';

export const LOMAVIS_TEMPLATE_POST_LOGO_PLACEHOLDER_SQUARE_ASPECT_RATIO = 1;
export const LOMAVIS_TEMPLATE_POST_LOGO_PLACEHOLDER_RECTANGLE_ASPECT_RATIO =
  2076 / 1257;

export const LOMAVIS_TEMPLATE_POST_SQUARE_LOGO_PLACEHOLDER_ID = 'square';
export const LOMAVIS_TEMPLATE_POST_RECTANGLE_LOGO_PLACEHOLDER_ID = 'rectangle';

export const MAX_IMAGE_PRODUCT_TAGS = 5;
export const MAX_POST_PRODUCT_TAGS = 20;
